//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../AME/AME.SelectAMEBaseNode.js";
import "../no/SelectObject.js";
let d=[[[1,"SelectedProduct",0,"AME.SelectAMEBaseNode",0]],[[["fileNameString"],"Add3dModel",{},1,0],[["fileNameString"],"Remove3dModel",{},1,0],[["fileNameString"],"SetDefaultModel",{},1,0],[[],"GetDefaultModel",{R_:{fileNameString:''}},0,0],[[],"ResetDefaultModel",{},0,0]],[]];
SPLM.AME.Manage3DModelsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.Manage3DModelsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;